/* tslint:disable */

declare var Object: any;
export interface ReferenceInterface {
  "id"?: number;
}

export class Reference implements ReferenceInterface {
  "id": number;
  constructor(data?: ReferenceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Reference`.
   */
  public static getModelName() {
    return "Reference";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Reference for dynamic purposes.
  **/
  public static factory(data: ReferenceInterface): Reference{
    return new Reference(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Reference',
      plural: 'References',
      path: 'References',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
